/* eslint-disable no-console */
/**
 * Print messages to console in development
 */
export const debugInfo = (message?: any, ...optionalParams: any[]) => {
    const isPlayground = window.location.pathname.includes('/playground/');

    if (process.env.NODE_ENV === 'development' || isPlayground) {
        console.warn(message, ...optionalParams);
    }
};

/**
 * Print messages to console in development AND production
 */
export const debugInfoProd = (message?: any, ...optionalParams: any[]) => {
    console.warn(message, ...optionalParams);
};
